import * as types from '../constants';

export const setGlobalFilterOpen = () => ({
   type: types.GLOBAL_FILTER_SET_OPEN,
});
export const setGlobalFilterClose = () => ({
   type: types.GLOBAL_FILTER_SET_CLOSE,
});
